module.exports = __webpack_public_path__ + "files/ef9fdd9140fc3708aa920f4328132576.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-3.png
// module id = 534
// module chunks = 76